import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 px-3 py-2 rounded-full bg-card/90 border border-border/40 backdrop-blur-xl text-xs text-foreground shadow-elevated"
      style={{ marginTop: "env(safe-area-inset-top)" }}
    >
      <WifiOff className="size-3.5 text-muted-foreground" />
      Sem conexão — suas ações serão sincronizadas
    </div>
  );
}
